import React from 'react';
import styled from '@emotion/styled';
import { Box } from '@mantine/core';

import { useIsMobileMedia } from '~/hooks';

import * as Styles from './Footer.styled';

const Flex = styled(Box)`
  display: flex;
  height: ${(p) => p.height};
  width: ${(p) => p.width};
  flex-direction: ${(p) => p.flexDirection};
  justify-content: ${(p) => p.justifyContent};
  align-items: ${(p) => p.alignItems};
`;

const Footer = () => {
  const isMobileMedia = useIsMobileMedia();

  const copyrightYear = Math.max(2022, new Date().getFullYear());

  return (
    <Styles.Root component="footer">
      <Styles.Container>
        <Styles.ContentWrapper>
          <Flex flexDirection={isMobileMedia ? 'column' : 'row'}>
            <Box flex="1">
              <Styles.LogoContainer href="https://upraised.co/" title="Upraised" target="_blank">
                <Styles.UpraisedLogo title="Upraised" />
              </Styles.LogoContainer>
            </Box>
            <Styles.LinksBlockWrapper component="nav">
              <Styles.LinksBlock>
                <Styles.LinkBlockHeading>Company</Styles.LinkBlockHeading>
                <Styles.LinkBlockLinks>
                  <Styles.StyledTextLink href="https://upraised.co/careers" title="Careers">
                    Careers
                  </Styles.StyledTextLink>
                  <Styles.StyledTextLink href="https://upraised.co/alumni" title="Success Stories">
                    Success Stories
                  </Styles.StyledTextLink>
                  {/* TODO: get links for Placement Report */}
                  {/* <Styles.StyledTextLink href="https://upraised.co" title="">
                    Placement Report
                  </Styles.StyledTextLink> */}
                </Styles.LinkBlockLinks>
              </Styles.LinksBlock>
              <Styles.LinksBlock>
                <Styles.LinkBlockHeading>Programs</Styles.LinkBlockHeading>
                <Styles.LinkBlockLinks>
                  <Styles.StyledTextLink
                    href="https://upraised.co/career-accelerator-program"
                    title="Career Accelerator Program"
                  >
                    CAP{!isMobileMedia ? ' - Full Time PM Jobs' : null}
                  </Styles.StyledTextLink>
                  <Styles.StyledTextLink href="https://upraised.co/preppa" title="Preppa">
                    Preppa{!isMobileMedia ? ' - Interview Preparation' : null}
                  </Styles.StyledTextLink>
                  {/* <Styles.StyledTextLink href="https://upraised.co/embark" title="Embark">
                    Embark{!isMobileMedia ? ' - Internships with Stipend' : null}
                  </Styles.StyledTextLink> */}
                  <Styles.StyledTextLink
                    href="https://upraised.co/kys-know-yourself-test"
                    title="KYS - Know Your Self Test"
                  >
                    KYS{!isMobileMedia ? ' - Know Your Self Test' : null}
                  </Styles.StyledTextLink>
                </Styles.LinkBlockLinks>
              </Styles.LinksBlock>
              <Styles.LinksBlock>
                <Styles.LinkBlockHeading>Resources</Styles.LinkBlockHeading>
                <Styles.LinkBlockLinks>
                  <Styles.StyledTextLink href="https://upraised.co/blog" title="Blog">
                    Blog
                  </Styles.StyledTextLink>
                  <Styles.StyledTextLink href="https://upraised.co/events" title="Live Events">
                    Live Events
                  </Styles.StyledTextLink>
                  <Styles.StyledTextLink href="https://upraised.co/free-product-management-course" title="PM Resources">
                    PM Resources
                  </Styles.StyledTextLink>
                  <Styles.StyledTextLink href="https://upraised.co/cap/roi" title="CAP ROI Calculator">
                    CAP ROI Calculator
                  </Styles.StyledTextLink>
                </Styles.LinkBlockLinks>
              </Styles.LinksBlock>
              {/* <Styles.LinksBlock>
                <Styles.LinkBlockHeading>For Employer</Styles.LinkBlockHeading>
                <Styles.LinkBlockLinks>
                  <Styles.StyledTextLink href="https://upraised.co/post-a-job" title="Hire Full Time">
                    Hire Full Time
                  </Styles.StyledTextLink>
                  <Styles.StyledTextLink href="https://upraised.co/embark/hire-interns" title="Hire Interns">
                    Hire Interns
                  </Styles.StyledTextLink>
                </Styles.LinkBlockLinks>
              </Styles.LinksBlock> */}
            </Styles.LinksBlockWrapper>
          </Flex>
          <Styles.CopyrightAndSocialLinksContainer>
            <Flex flexDirection={isMobileMedia ? 'column' : 'row'}>
              <Styles.CopyrightText style={{ pointerEvents: 'none' }}>
                © {copyrightYear} Upraised Technology Pvt Ltd
              </Styles.CopyrightText>
              <Styles.CopyrightText href="https://upraised.co/privacy-policy" title="Privacy Policy">
                Privacy Policy
              </Styles.CopyrightText>
              <Styles.CopyrightText href="https://upraised.co/terms" title="Terms and Conditions">
                Terms and Conditions
              </Styles.CopyrightText>
            </Flex>
            <Styles.SocialIconsWrapper>
              <Box
                component="a"
                href="https://www.linkedin.com/company/upraised/"
                title="Upraised on Linkedin"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Styles.LinkedInLogo />
              </Box>
              <Box
                ml="16px"
                component="a"
                href="https://twitter.com/getupraised"
                title="Upraised on Twitter"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Styles.TwitterLogo />
              </Box>
              <Box
                ml="16px"
                component="a"
                href="https://www.youtube.com/c/Upraised"
                title="Upraised Youtube Channel"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Styles.YoutubeLogo />
              </Box>
              <Box
                ml="16px"
                component="a"
                href="https://www.instagram.com/getupraised"
                title="Upraised on Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Styles.InstagramLogo />
              </Box>
            </Styles.SocialIconsWrapper>
          </Styles.CopyrightAndSocialLinksContainer>
        </Styles.ContentWrapper>
      </Styles.Container>
    </Styles.Root>
  );
};

export default Footer;
